import { createContext } from "react";

const UserContext = createContext({
  token: localStorage.getItem("token") ? localStorage.getItem("token") : "",
  user: {},
  setUser: () => {},
  friends: [],
  setFriends: () => {},
  posts: [],
  setPosts: () => {},
});

export default UserContext;
